import { Categoria } from "./categoria";

export class ConfiguracaoCategoriaOrcamento {
  categorias: Categoria[];
}
